module.exports = __webpack_public_path__ + "static/media/store.e820ccea.svg";